import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopHeader from "./TopHeader";
import Cami from "./Cami";
import { useAuth } from "../context/AuthContext";

const PAGE_META = {
  "/onboarding": { title: "My Onboarding", subtitle: "Follow your path from profile setup to client ready." },
  "/documents": { title: "My Documents", subtitle: "Upload, track, and manage your onboarding paperwork." },
  "/training": { title: "Training", subtitle: "Complete your core learning modules." },
  "/assessment": { title: "Assessment", subtitle: "Pass the final assessment to earn certification." },
  "/certification": { title: "Certification", subtitle: "Your Customer Service Representative credential." },
  "/opportunities": { title: "Opportunity Center", subtitle: "Browse and accept client opportunities." },
  "/client-journey": { title: "Client Journey", subtitle: "From requirements to client ready." },
  "/announcements": { title: "Announcements", subtitle: "Company news, cohort schedules, and policy updates." },
  "/support": { title: "Support", subtitle: "Get help with onboarding, documents, and certification." },
  "/profile": { title: "My Profile", subtitle: "Manage your contact details, address, and tax information." },
  "/settings": { title: "Settings", subtitle: "Manage your account preferences and security." },
  "/equipment": { title: "Equipment Requirements", subtitle: "Verify your computer, internet, headset, and workspace." },
  "/metrics": { title: "Admin Dashboard", subtitle: "Workforce onboarding, compliance, and business metrics." },
  "/payroll": { title: "Payroll", subtitle: "Manage pay periods, earnings, and disbursements." },
  "/users": { title: "People", subtitle: "Manage applicants, supervisors, and administrators." },
  "/admin/applicant-data": { title: "Applicant Data", subtitle: "Availability and equipment requests across applicants." },
  "/supervisor/applicants": { title: "My Applicants", subtitle: "Contractors assigned to you." },
  "/admin/content": { title: "Training Content", subtitle: "Add and manage training, assessment, and opportunities." },
  "/admin/documents": { title: "Document Review Center", subtitle: "Approve or reject applicant document uploads." },
  "/admin/certificates": { title: "Certificate Manager", subtitle: "View and manage certified representatives." },
  "/admin/reports": { title: "Reports & Analytics", subtitle: "Documents, training, and certification breakdowns." },
  "/admin/notifications": { title: "Notifications Manager", subtitle: "Publish announcements to all applicants." },
  "/admin/cami": { title: "Cami AI Management", subtitle: "Usage stats and assistant knowledge." },
  "/admin/system": { title: "System Settings", subtitle: "Core configuration for the portal." },
  "/admin/workforce": { title: "Workforce Snapshot", subtitle: "Live training, readiness, and production status across the workforce." },
  "/admin/programs": { title: "Client Programs", subtitle: "Review programs, control contractor pay, publish, and assign." },
  "/admin/clients": { title: "Client Companies", subtitle: "Manage client companies and client portal logins." },
  "/admin/patriot": { title: "Patriot Setup", subtitle: "Track each contractor's Patriot onboarding status." },
  "/admin/audit": { title: "Audit Log", subtitle: "A trail of sensitive actions across the portal." },
  "/my-program": { title: "My Program", subtitle: "Your assignment, training status, and pay rate." },
  "/supervisor/hub": { title: "Supervisor Hub", subtitle: "Everything you need to support your contractors." },
  "/client-dashboard": { title: "Client Dashboard", subtitle: "Your programs, contractors, and training at a glance." },
  "/client-programs": { title: "My Programs", subtitle: "Create and submit hiring programs for review." },
  "/client-contractors": { title: "My Contractors", subtitle: "Contractors assigned to your programs." },
  "/client-reports": { title: "Weekly Report", subtitle: "A weekly summary of your programs." },
};

export default function PortalLayout() {
  const location = useLocation();
  const { user } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  let meta = PAGE_META[location.pathname] || { title: "Campbell Connect" };
  if (location.pathname === "/dashboard") {
    meta = {
      title: `Welcome back, ${user?.first_name || ""}`,
      subtitle: "Here is where you stand on your path to certification.",
    };
  }

  return (
    <div className="flex min-h-screen bg-background">
      <div className="hidden md:block">
        <div className="sticky top-0 h-screen">
          <Sidebar />
        </div>
      </div>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-slate-900/40" onClick={() => setMobileOpen(false)} />
          <div className="absolute left-0 top-0 h-full">
            <Sidebar onNavigate={() => setMobileOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col">
        <TopHeader title={meta.title} subtitle={meta.subtitle} onMenuClick={() => setMobileOpen(true)} />
        <main className="flex-1 px-5 py-6 md:px-8">
          <div className="mx-auto max-w-5xl">
            <Outlet />
          </div>
        </main>
      </div>
      <Cami />
    </div>
  );
}
